/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function supply(instance) {
	return {
		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getBasePageFilters: (config = {}) => {
			return instance.get(`supply`, config)
		},

		/**
		 * @param {{name:string}} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getBasePage: (body, config = {}) => {
			return instance.post(`supply`, body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		createAllocations: (body, config = {}) => {
			return instance.post('supply/allocations', body, config)
		},

		/**
		 * @param {number} season
		 * @param {number} retailerId
		 * @param {number} recieverId
		 * @param {number} transportTypeId
		 * @param {number} marketId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getHistory: (
			season,
			retailerId,
			recieverId,
			transportTypeId,
			marketId,
			config = {}
		) => {
			const seasonParam = season ? `season=${season}&` : ''
			const retailerIdParm = retailerId ? `retailerId=${retailerId}&` : ''
			const recieverIdParam = recieverId ? `recieverId=${recieverId}&` : ''
			const transportTypeIdParam = transportTypeId
				? `transportTypeId=${transportTypeId}&`
				: ''
			const marketIdParam = marketId ? `marketId=${marketId}&` : ''

			const params = `${seasonParam}${retailerIdParm}${recieverIdParam}${transportTypeIdParam}${marketIdParam}`
			return instance.get(`supply/history?${params}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllocationsFilters: (body, config = {}) => {
			return instance.post(`supply/allocation/filter`, body, config)
		},

		/**
		 * @param {{name:string}} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllocationData: (body, config = {}) => {
			return instance.post(`supply/allocation`, body, config)
		},

		/**
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {number} regionId
     * @param {number} week
     * @param {number} retailerId
     * @param {number} transportTypeId
     * @param {number} marketId

     * @param {import("axios").AxiosRequestConfig} config
     */
		getPackingInstructions: (
			pageNumber,
			pageSize,
			marketId,
			retailerId,
			transportTypeId,
			week,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''

			const marketIdParam = marketId ? `marketId=${marketId}&` : ''
			const retailerIdParam = retailerId ? `retailerId=${retailerId}&` : ''
			const transportTypeIdParam = transportTypeId
				? `transportTypeId=${transportTypeId}&`
				: ''
			const weekParam = week ? `week=${week}&` : ''

			return instance.get(
				`supply/packing_instruction${params}${marketIdParam}${retailerIdParam}${weekParam}${transportTypeIdParam}`,
				config
			)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getPackingInstructionsFilters: (config = {}) => {
			return instance.get(`supply/packing_instruction/filter`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFinalWeek: (config = {}) => {
			return instance.get(`supply/final_week`, config)
		}
	}
}
